import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NugetPackageContent } from '../../models/nuget-package-content';
import { NugetFeed } from '../../models/nuget-feed';

import { CollapsiblePanelComponent } from '../../../shared/collapsible-panel/collapsible-panel.component';
import { XmlArtifactGridComponent } from '../../developer-artifacts/xml-artifact-grid/xml-artifact-grid.component';
import { AssemblyArtifactGridComponent } from '../../developer-artifacts/assembly-artifact-grid/assembly-artifact-grid.component';

@Component({
    templateUrl: './nuget-package-install-dialog.component.html',
    styleUrls: ['./nuget-package-install-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CollapsiblePanelComponent, XmlArtifactGridComponent, AssemblyArtifactGridComponent]
})
export class NugetPackageInstallDialogComponent implements OnInit {

    nugetPackages: NugetPackageContent[] = [];
    nugetFeeds: NugetFeed[] = [];

    constructor(public modal: NgbActiveModal) {}

    async ngOnInit(): Promise<void> {
    }

    ok(): void {
        this.modal.close(this.nugetPackages);
    }

    cancel(): void {
        this.modal.dismiss();
    }

    getNugetPackageName(nugetFeedId: number, nugetPackageId) {
        const nugetFeed = this.nugetFeeds.find((feed) => feed.Id === nugetFeedId);
        const nugetPackage = nugetFeed?.Packages.find((p) => p.Identity.Id === nugetPackageId);

        return nugetFeed?.Name + ' --> ' + nugetPackage?.Title + ' (' + nugetPackage.Identity.Version.OriginalVersion + ')';
    }

    getNugetPackageIconUrl(nugetFeedId: number, nugetPackageId) {
        const nugetFeed = this.nugetFeeds.find((feed) => feed.Id === nugetFeedId);
        const nugetPackage = nugetFeed?.Packages.find((p) => p.Identity.Id === nugetPackageId);

        return nugetPackage.IconUrl ?? '/images/nuget-package.png';
    }
}
